import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import TweenMax from 'gsap'

// Components
import "./style.css";
import { capitalizeString } from "../../helpers/helpers";

class ChurchFacts extends Component {
    constructor() {
        super();

        this.state = {
            readMore: "+ Flere fakta og fasiliteter",
        };

        // this.toggleFacts = this.toggleFacts.bind(this)
    }

    toggleFacts() {
        /*
    const open = this.hiddenFacts.classList.contains('church-facts__hidden--open')

    if (!open) {
      TweenMax.set(this.hiddenFacts, {height: 'auto'})
      const factHeight = this.hiddenFacts.clientHeight
      this.hiddenFacts.classList.add('church-facts__hidden--open')

      TweenMax.fromTo(this.hiddenFacts, 0.4, {height: '0px'}, {height: `${factHeight}px`})
      this.setState({ readMore: '- Vis mindre'})
    } else {
      TweenMax.to(this.hiddenFacts, 0.4, {height: '0px'})
      this.hiddenFacts.classList.remove('church-facts__hidden--open')
      this.setState({ readMore: '+ Mer om tilgjengelighet'})
    }
    */
    }

    render() {
        const {
            constructionYear,
            parishName,
            countyName,
            municipalityName,
            street,
            postalCode,
            postalArea,
            approvedCapacity,
            catering,
            guidedTours,
        } = this.props.church;

        if (
            [
                constructionYear,
                parishName,
                countyName,
                municipalityName,
                street,
                postalCode,
                postalArea,
                approvedCapacity,
                catering,
                guidedTours,
            ].every((prop) => prop === undefined || prop === null)
        ) {
            return null;
        }

        return (
            <div className="church-facts__wrapper church-facts__wrapper--yellow">
                <div className="church-facts__inner">
                    <h3 className="church-facts__title">Fakta</h3>
                    {constructionYear && (
                        <p>
                            <strong>Byggeår: </strong>
                            {constructionYear}
                        </p>
                    )}
                    {parishName && (
                        <p>
                            <strong>Sokn: </strong>
                            {capitalizeString(parishName)}
                        </p>
                    )}
                    {countyName && (
                        <p>
                            <strong>Fylke: </strong>
                            {countyName}
                        </p>
                    )}
                    {municipalityName && (
                        <p>
                            <strong>Kommune: </strong>
                            {municipalityName}
                        </p>
                    )}
                    {street && postalCode && postalArea && (
                        <p>
                            <strong>Gateadresse: </strong>
                            {/* <Link
                                    target="_blank"
                                    to={`https://www.google.com/maps/?q=${church.latlngkoordinat.lat},${church.latlngkoordinat.lon}`}
                                > */}
                            {`${street}, ${postalCode} ${postalArea}`}
                            {/* </Link> */}
                        </p>
                    )}
                    {approvedCapacity && (
                        <p>
                            <strong>Godkjente Sitteplasser: </strong>
                            {approvedCapacity}
                        </p>
                    )}
                    {catering && (
                        <p>
                            <strong>Servering: </strong>
                            {catering}
                        </p>
                    )}
                    {guidedTours && (
                        <p>
                            <strong>Omvisning: </strong>
                            {guidedTours}
                        </p>
                    )}

                    {/* {church.bispedomme && (
                        <p>
                            <strong>Bispedømme: </strong>
                            {church.bispedomme}
                        </p>
                    )}
                    {church.prosti && (
                        <p>
                            <strong>Prosti: </strong>
                            {church.prosti}
                        </p>
                    )}
                    {church.veibeskrivelse && (
                        <p>
                            <strong>Veibeskrivelse: </strong>
                            {church.veibeskrivelse}
                        </p>
                    )}
                    {church.nattkirke && (
                        <p>
                            <strong>Nattkirke: </strong>Ja
                        </p>
                    )}
                    {church.teleslyngeanlegg && (
                        <p>
                            <strong>Teleslyngeanlegg: </strong>Ja
                        </p>
                    )}
                    {church.norgeskirker && (
                        <p>
                            <strong>Norgeskirker: </strong>Ja
                        </p>
                    )} */}
                    {/* </div> */}
                </div>
            </div>
        );
    }
}

export default ChurchFacts;



// WEBPACK FOOTER //
// ./src/components/ChurchFacts/index.js